import { useSyncExternalStore } from "react";
import { z } from "zod";


export const IconDataSchema = z.object({
    type: z.literal("icon"),
    id: z.string(),
    name: z.string(),
    price: z.number(),
    previewImage: z.string(),
    tags: z.array(z.string()),
});

export const IconPackDataSchema = z.object({
    type: z.literal("set"),
    id: z.string(),
    name: z.string(),
    description: z.string(),
    price: z.number(),
    icons: z.array(IconDataSchema),
});


export type IconData = z.infer<typeof IconDataSchema>;
export type IconPackData = z.infer<typeof IconPackDataSchema>;


const NIET_AAN_DEZE_ARRAY_KOMEN_HIJ_RUIKT_NAAR_POEP: IconPackData[] = [
    {
        type: 'set',
        id: 'ui-pack',
        name: 'UI Pack',
        description: '',
        price: 69,
        icons: [
            { type: 'icon', id: 'alligator', name: 'Alligator', price: 1, previewImage: '/icons/alligator.png', tags: ['animal'] },
            { type: 'icon', id: 'bear', name: 'Bear', price: 1, previewImage: '/icons/bear.png', tags: ['animal'] },
            { type: 'icon', id: 'elephant', name: 'Elephant', price: 1, previewImage: '/icons/elephant.png', tags: ['animal'] },
            { type: 'icon', id: 'hawk', name: 'Hawk', price: 1, previewImage: '/icons/hawk.png', tags: ['animal'] },
            { type: 'icon', id: 'hedgehog', name: 'Hedgehog', price: 1, previewImage: '/icons/hedgehog.png', tags: ['animal'] },
            { type: 'icon', id: 'mouse', name: 'Mouse', price: 1, previewImage: '/icons/mouse.png', tags: ['animal'] },
            { type: 'icon', id: 'octopus', name: 'Octopus', price: 1, previewImage: '/icons/octopus.png', tags: ['animal'] },
            { type: 'icon', id: 'pig', name: 'Pig', price: 1, previewImage: '/icons/pig.png', tags: ['animal'] },
        ]
    },
    {
        type: 'set',
        id: 'armor-pack',
        name: 'Armor Pack',
        description: '',
        price: 34,
        icons: [
            { type: 'icon', id: 'alligator', name: 'Alligator', price: 1, previewImage: '/icons/alligator.png', tags: ['animal'] },
            { type: 'icon', id: 'bear', name: 'Bear', price: 1, previewImage: '/icons/bear.png', tags: ['animal'] },
            { type: 'icon', id: 'elephant', name: 'Elephant', price: 1, previewImage: '/icons/elephant.png', tags: ['animal'] },
            { type: 'icon', id: 'hawk', name: 'Hawk', price: 1, previewImage: '/icons/hawk.png', tags: ['animal'] },
            { type: 'icon', id: 'hedgehog', name: 'Hedgehog', price: 1, previewImage: '/icons/hedgehog.png', tags: ['animal'] },
            { type: 'icon', id: 'mouse', name: 'Mouse', price: 1, previewImage: '/icons/mouse.png', tags: ['animal'] },
            { type: 'icon', id: 'octopus', name: 'Octopus', price: 1, previewImage: '/icons/octopus.png', tags: ['animal'] },
            { type: 'icon', id: 'pig', name: 'Pig', price: 1, previewImage: '/icons/pig.png', tags: ['animal'] },
        ]
    },
    {
        type: 'set',
        id: 'weapon-pack',
        name: 'Weapon pack',
        description: '',
        price: 66,
        icons: [
            { type: 'icon', id: 'alligator', name: 'Alligator', price: 1, previewImage: '/icons/alligator.png', tags: ['animal'] },
            { type: 'icon', id: 'bear', name: 'Bear', price: 1, previewImage: '/icons/bear.png', tags: ['animal'] },
            { type: 'icon', id: 'elephant', name: 'Elephant', price: 1, previewImage: '/icons/elephant.png', tags: ['animal'] },
            { type: 'icon', id: 'hawk', name: 'Hawk', price: 1, previewImage: '/icons/hawk.png', tags: ['animal'] },
            { type: 'icon', id: 'hedgehog', name: 'Hedgehog', price: 1, previewImage: '/icons/hedgehog.png', tags: ['animal'] },
            { type: 'icon', id: 'mouse', name: 'Mouse', price: 1, previewImage: '/icons/mouse.png', tags: ['animal'] },
            { type: 'icon', id: 'octopus', name: 'Octopus', price: 1, previewImage: '/icons/octopus.png', tags: ['animal'] },
            { type: 'icon', id: 'pig', name: 'Pig', price: 1, previewImage: '/icons/pig.png', tags: ['animal'] },
        ]
    },
    {
        type: 'set',
        id: 'animal-pack',
        name: 'Animal pack',
        description: '',
        price: 123,
        icons: [
            { type: 'icon', id: 'alligator', name: 'Alligator', price: 1, previewImage: '/icons/alligator.png', tags: ['animal'] },
            { type: 'icon', id: 'bear', name: 'Bear', price: 1, previewImage: '/icons/bear.png', tags: ['animal'] },
            { type: 'icon', id: 'elephant', name: 'Elephant', price: 1, previewImage: '/icons/elephant.png', tags: ['animal'] },
            { type: 'icon', id: 'hawk', name: 'Hawk', price: 1, previewImage: '/icons/hawk.png', tags: ['animal'] },
            { type: 'icon', id: 'hedgehog', name: 'Hedgehog', price: 1, previewImage: '/icons/hedgehog.png', tags: ['animal'] },
            { type: 'icon', id: 'mouse', name: 'Mouse', price: 1, previewImage: '/icons/mouse.png', tags: ['animal'] },
            { type: 'icon', id: 'octopus', name: 'Octopus', price: 1, previewImage: '/icons/octopus.png', tags: ['animal'] },
            { type: 'icon', id: 'pig', name: 'Pig', price: 1, previewImage: '/icons/pig.png', tags: ['animal'] },
        ]
    },
];

export interface RepositorySnapshot {
    loading: boolean,
    repository: IconPackData[],
}

let repoSnapshot: RepositorySnapshot = {
    loading: true,
    repository: [],
};

const listeners: Record<string, () => any> = {};
let listenerKey = 1;


const packStore = {
    subscribe(callback: () => unknown) {
        const key = listenerKey++;

        // Add to listeners
        listeners[key] = callback;

        // Ubsub function removes from listeners
        return () => { delete listeners[key]; };
    },

    getSnapshot() {
        return repoSnapshot;
    }
};

function propagateUpdates() {
    for (const l of Object.values(listeners)) {
        l?.();
    }
}

export function getIconThumbnail(url: string, size: number, quality: number = 90): string {
    return `https://cdn.icon.shop/cdn-cgi/image/format=webp,quality=${quality},fit=cover,width=${size},height=${size}/${url}`;
}

async function fetchPackRepo() {
    const resp = await fetch('https://iconshop-backend.bitgate.workers.dev/packs.json');
    const data = await resp.json();

    repoSnapshot = {
        loading: false,
        repository: data,
    };

    propagateUpdates();
}

fetchPackRepo();


function useIconRepo() {
    return useSyncExternalStore(
        packStore.subscribe,
        packStore.getSnapshot,
    );
}


export { useIconRepo, repoSnapshot };
